import { createSlice } from '@reduxjs/toolkit';
import Moment from 'moment';
import { DateRange } from './dateRangeSlice';

export const getCurrentLiveDateRange: () => DateRange = () => ({
  start: Moment().subtract(60, 'minutes').toDate()
    .toISOString(),
  end: Moment().toISOString(),
  selectedRange: 7,
});

const initialState: DateRange = getCurrentLiveDateRange();

const dateRangeSlice = createSlice({
  name: 'liveDateRange',
  initialState,
  reducers: {
    refreshLiveDateRange(state: DateRange) {
      const updatedLiveDateRange = getCurrentLiveDateRange();
      state.start = updatedLiveDateRange.start;
      state.end = updatedLiveDateRange.end;
    },
  },
});

export const { refreshLiveDateRange } = dateRangeSlice.actions;

export default dateRangeSlice.reducer;
